import { useMutation } from "react-query";
import { useConfig } from "../../utils/useConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { markCommunicationAsRead } from "../../mutations/communications/markCommunicationRead";
import { useData } from "../../utils/useData";

export const useMarkCommunicationRead = (
    options?: {
        onSuccess?: () => void;
        onError?: (error: Error) => void;
        successMessage?: string;
    }
) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { communications, employer, userInfoData } = useData();

    return useMutation(
        async (communicationId: string) => await markCommunicationAsRead(
            communicationId, 
            config, 
            await getToken(),
            employer.data?.id ?? "",
            userInfoData?.employeeId ?? ""
        ),
        {
            onSuccess: () => {
                communications.refetch();
                options?.onSuccess?.();
            },
            onError: (error: Error) => {
                options?.onError?.(error);
            }
        }
    );
}